export default Object.freeze({
  FULL: 'Full',
  SHORT: 'Short',
  ICON: 'Icon',
  NONE: '',
})
